<dgx-orgs-internal-content-visibility
  [hideTitle]="true"
  [orgId]="orgId"
  [groupIds]="selectedGroupIds"
  [groupNames]="selectedGroupNames"
  [visibleToOrg]="params.isVisibleToOrg"
  (setVisibilityValues)="handleSetVisibilityValues($event)"
></dgx-orgs-internal-content-visibility>
